import React, { useState } from 'react';
import { Image as WDSImage } from '@wix/design-system';
import s from './Picture.module.scss';
export const Picture = _ref => {
  let {
    url,
    fit = 'cover',
    verticalAlign,
    horizontalAlign,
    aspectRatio = '1/1'
  } = _ref;
  const [imageHeight, setImageHeight] = useState(undefined);
  const imageWidth = fit === 'original' ? 'auto' : '100%';
  const imageSrc = url;
  const imageFit = fit === 'original' ? undefined : fit;
  const xAlign = horizontalAlign ?? (fit === 'contain' ? 'left' : 'center');
  const yAlign = verticalAlign ?? 'center';
  const imagePosition = fit === 'original' ? undefined : `${xAlign} ${yAlign}`;
  const calcImageHeightForFitContain = node => {
    /**
     * For fit='contain'
     * The maximum height of the image should be determined by the aspect ratio defined in the CSS.
     * This rule applies until the image's original height is less than the calculated aspect ratio vertical space.
     */
    if (node && fit === 'contain') {
      const containerWidth = node.clientWidth;
      const containerHeight = node.clientHeight;
      const containerAspectRatio = containerWidth / containerHeight;
      if (imageSrc) {
        const img = new Image();
        img.src = imageSrc;
        img.onload = () => {
          const imageAspectRatio = img.width / img.height;
          if (img.height < containerHeight) {
            setImageHeight(Math.round(img.height));
            return;
          }
          const renderedHeight = imageAspectRatio > containerAspectRatio ? containerWidth / imageAspectRatio : containerHeight;
          if (renderedHeight < containerHeight) {
            setImageHeight(Math.round(renderedHeight));
            return;
          }
        };
      }
    }
  };
  const imageStyle = {
    aspectRatio: fit === 'original' ? 'unset' : aspectRatio
  };
  const imageElement = /*#__PURE__*/React.createElement("div", {
    ref: calcImageHeightForFitContain,
    className: s.image
  }, /*#__PURE__*/React.createElement(WDSImage, {
    src: imageSrc,
    fit: imageFit,
    width: imageWidth,
    height: imageHeight,
    transparent: true,
    position: imagePosition,
    borderRadius: "4px",
    style: imageStyle
  }));
  return imageSrc ? imageElement : null;
};
//# sourceMappingURL=Picture.js.map